import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    creditReport:{},
    error:'',
    status:'idle'
};

export const fetchCreditReport = createAsyncThunk('credit-report/fetchCreditReport', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('Form/getCreditReportsData',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});


const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const creditReportSlice = createSlice({
    name:'credit-report',
    initialState,
    reducers:{
        blankCreditReport:(state)=>{
            state.creditReport = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchCreditReport.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchCreditReport.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.creditReport = action.payload;
            state.error = '';
        })
        builder.addCase(fetchCreditReport.rejected,(state,action)=>{
            state.status = 'failed';
            state.creditReport = {};
            state.error = action.error.message;
        })
    }
})

export const {blankCreditReport} = creditReportSlice.actions;

export default creditReportSlice.reducer;